module.exports = __webpack_public_path__ + "img/productManualBj.8e0a9aeb.png";